import { apiClient } from '@/services';
import type { ApiResponse } from '@macroinsight/shared-types';
import { z } from 'zod/v3';

const requestOtpDataSchema = z.object({
  email: z.string().email()
});

const verifyOtpDataSchema = z.object({
  email: z.string().email(),
  otp: z.string().length(6)
});

export type RequestOtpData = z.infer<typeof requestOtpDataSchema>;
export type VerifyOtpData = z.infer<typeof verifyOtpDataSchema>;

export async function requestOtpAction(data: RequestOtpData): Promise<ApiResponse<null>> {
  const validatedData = requestOtpDataSchema.parse(data);

  const response = await apiClient.post<null>('/api/auth/request-otp-code', validatedData);

  if (!response.success) {
    throw new Error(response.message ?? 'Failed to send OTP code');
  }

  return response;
}

export async function verifyOtpAction(data: VerifyOtpData): Promise<ApiResponse<any>> {
  const validatedData = verifyOtpDataSchema.parse(data);

  const response = await apiClient.post<any>('/api/auth/verify-otp', validatedData);

  return response;
}
